(function() {
    $(function() {
        $("#new_message").click(function(event) {
            event.preventDefault();
            event.stopPropagation();
            return $.growl.notice({
                title: "Aviso", 
                message: "Você tem novas mensagens"
            });
        });
    });
}).call(this);
